/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Picture from 'components/Picture/Picture';
import Statement from '../Statement/Statement';
import './StatementImage.scss';

/**
 * This is the StatementImage component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function StatementImage({
  layout,
  statement,
  image: { description, ...image },
}) {
  function renderDescription() {
    if (!description) return null;

    return <figcaption dangerouslySetInnerHTML={{ __html: description }} />;
  }

  return (
    <div className={`block statement-image layout-${layout}`}>
      <Statement>{statement}</Statement>
      <figure className="image" appear="true">
        <Picture {...image} />
        {renderDescription()}
      </figure>
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
StatementImage.propTypes = {
  layout: PropTypes.string.isRequired,
  statement: PropTypes.string,
  image: PropTypes.object.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
StatementImage.defaultProps = {
  layout: 'right',
  statement: '',
  image: {},
};

export default StatementImage;
